/* eslint-disable no-unused-vars */
export enum ColId {
  //Main table col ids.
  //They may be duplicate fields of nested table colids, but do not change.
  //Changes will cause disruptions to the selenium tests
  ActionSummaryStatusCell = "ActionSummaryStatusCell",
  ActionSummaryCounterpartyHeader = "ActionSummaryCounterpartyHeader",

  expand = "expand",
  expandMocked = "expandMocked", // Used to fake a filler cell where a real expand would be.
  order = "order",
  bid = "bid",
  ask = "ask",
  mid = "mid",
  bidRepo = "bidRepo",
  askRepo = "askRepo",
  midRepo = "midRepo",
  bidOutright = "bidOutright",
  askOutright = "askOutright",
  midOutright = "midOutright",
  direction = "direction",
  directionOutright = "directionOutright",
  dealer = "dealer",
  cash = "cash",
  indicativeCash = "indicativeCash",
  provider = "provider",
  status = "status",
  lastAction = "lastAction",
  level = "level", // ORDER
  refPrice = "refPrice", // ORDER
  filledPercent = "filledPercent", // ORDER
  filledAt = "filledAt", // ORDER
  indicativeMid = "indicativeMid",
  indicativeMidOutright = "indicativeMidOutright",
  feeAdjustedQuote = "feeAdjustedQuote",
  // feeAdjustedQuoteOutright = "feeAdjustedQuoteOutright",
  dealtRepoRate = "dealtRepoRate",
  dealtStrike = "dealtStrike", // dealt strike on OP (but headerName = Strike)
  dealtStrikeOutright = "dealtStrikeOutright",
  strike = "strike", //strike on RP
  strikeOutright = "strikeOutright",
  notionalLeg1 = "notionalLeg1",
  notionalLeg1Outright = "notionalLeg1Outright",
  notionalLeg2Outright = "notionalLeg2Outright",
  cpiLeg1 = "cpiLeg1",
  cpiLeg1Outright = "cpiLeg1Outright",
  cpiIndex = "cpiIndex",
  cpiIndexOutright = "cpiIndexOutright",
  quotedSize = "quotedSize",
  quotedSizeOutright = "quotedSizeOutright",
  percentQuoted = "percentQuoted",
  percentQuotedOutright = "percentQuotedOutright",
  percentIceberg = "percentIceberg", // API ReleaseSize
  percentIcebergOutright = "percentIcebergOutright", // API ReleaseSize
  // QUOTE EXPIRY - later phase, not the current rollout. No base colDef exists,
  // so references to this render nothing. See docs/features/TRADE_EXPIRY.md
  validUntil = "validUntil",
  settlementDateOutright = "settlementDateOutright",
  security = "security",
  securityOutright = "securityOutright",
  isin = "isin",
  isinOutright = "isinOutright",
  coupon = "coupon",
  couponOutright = "couponOutright", // 14751
  referenceIndex = "referenceIndex",
  quotedMargin = "quotedMargin",
  currentCoupon = "currentCoupon",
  referenceIndexOutright = "referenceIndexOutright",
  quotedMarginOutright = "quotedMarginOutright",
  currentCouponOutright = "currentCouponOutright",
  settlementDate = "settlementDate",
  refAsset = "refAsset",
  minClip = "minClip",
  fillQuantity = "fillQuantity",
  fillPrice = "fillPrice",
  expiryDate = "expiryDate",
  deliveryDate = "deliveryDate",
  extStructureId = "extStructureId",
  notionalLeg2 = "notionalLeg2",
  leg = "leg",
  book = "book",
  referenceRates = "reference",
  executionFee = "executionFee",
  executionFeeOutright = "executionFeeOutright",
  dealtFee = "dealtFee",
  dealtFeeOutright = "dealtFeeOutright",
  startFiller = "startFiller",
  unwind = "unwind",
  // RP-side conditional columns — surfaced when the backend populates the
  // matching field on the trade root (set by the OP advising the RP).
  cover = "cover",
  coverSpread = "coverSpread",
  releaseCompetition = "releaseCompetition",
  competition = "competition",
  //filler?

  //View Blocks/ View Legs

  viewBlockIsin = "ViewBlockIsin",
  viewBlockSecurityName = "ViewBlockSecurityName",
  viewBlockDirection = "ViewBlockDirection",
  ViewBlockNotionalLeg1 = "ViewBlockNotionalLeg1",
  viewBlockdv01 = "ViewBlockdv01",
  viewBlockEffectiveDate = "ViewBlockEffectiveDate",
  viewBlockExtStructureId = "ViewBlockExtStructureId",
  viewBlockTransactionType = "ViewBlockTransactionType",
  viewBlockNPV = "ViewBlockNPV",
  viewBlockRecoupon = "ViewBlockRecoupon",
  viewBlockCoupon = "ViewBlockCoupon",
  viewBlockIndicativeMid = "ViewBlockIndicativeMid",
  viewBlockIndicativeNPV = "ViewBlockIndicativeNPV",

  // FRN specific (LQC-2153)
  viewBlockReferenceIndex = "ViewBlockReferenceIndex",
  viewBlockQuotedMargin = "ViewBlockQuotedMargin",
  viewBlockCurrentCoupon = "ViewBlockCurrentCoupon",

  // Order specific
  viewBlockReferencePrice = "ViewBlockReferencePrice",
  viewBlockReferenceSpread = "ViewBlockReferenceSpread",
  viewBlockReferenceAsset = "ViewBlockReferenceAsset",
  addFillButton = "addFillButton",
  editFillButton = "editFillButton",
}
